const APP_PATH = /^\/app(?:[/?#]|$)/;

/**
 * The same-origin path under `/app` that `candidate` names, or null. Anything
 * else (absolute and protocol-relative URLs, backslash tricks, dot segments
 * leaving `/app`) is refused, so no input can become an open redirect.
 *
 * @param {*} candidate a path with optional query and hash
 * @returns {string|null}
 */
const sameOriginAppPath = (candidate) => {
  if (typeof candidate !== 'string' || !APP_PATH.test(candidate) || candidate.includes('\\')) {
    return null;
  }
  try {
    const target = new URL(candidate, window.location.origin);
    if (target.origin !== window.location.origin || !APP_PATH.test(target.pathname)) return null;
    return `${target.pathname}${target.search}${target.hash}`;
  } catch {
    return null;
  }
};

export default sameOriginAppPath;
